import { openDialog, WebDialog } from "web-dialog";
import { html, render } from "lit";
import { Idea, Ref } from "shared";

export async function openViewIdea(idea: Ref<Idea>) {
	import("../molecules/idea");
	return await openDialog<WebDialog>({
		initialize: () => {
			const $d = new WebDialog();
			$d.style.setProperty("--dialog-max-width", "500px");
			$d.style.setProperty("--dialog-padding", "0");
			return $d;
		},
		center: true,
		$content: ($dialog) => render(html` <bs-idea .idea="${idea}" size="large"></bs-idea> `, $dialog)
	}).resolver;
}
